import React from 'react';
import { Button, Form } from 'react-bootstrap';

export default function BrowseSearchBar({
  id,
  label,
  placeholder,
  value,
  onChange,
  onClear,
  hint,
  searching = false,
  className = ''
}) {
  return (
    <div className={`recv-browse-search-bar${className ? ` ${className}` : ''}`}>
      <Form.Label className="recv-browse-search-bar__label" htmlFor={id}>
        {label}
      </Form.Label>
      <div className="recv-browse-search-bar__input-wrap">
        <span className="recv-browse-search-bar__glyph" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M10.5 4a6.5 6.5 0 014.1 11.6l4.4 4.4-1.4 1.4-4.4-4.4A6.5 6.5 0 1110.5 4zm0 2a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
              fill="currentColor"
            />
          </svg>
        </span>
        <Form.Control
          id={id}
          type="search"
          className="recv-browse-search-bar__input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
        />
        {value ? (
          <Button
            variant="link"
            className="recv-browse-search-bar__clear"
            onClick={() => (onClear ? onClear() : onChange?.(''))}
          >
            Effacer
          </Button>
        ) : null}
      </div>
      {hint ? (
        <div className="recv-browse-search-bar__hint small text-muted mt-1">
          {searching ? 'Recherche en cours…' : hint}
        </div>
      ) : null}
    </div>
  );
}
